var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { RouteFiller } from "../helpers/Helpers";
import { CollaborationServiceSetup } from "../Setup";
export var ValuesController = {
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "api/values" and http method "GET" to call the back-end.
    
        * @returns {void}
    ******************************************************************************************************/
    Get: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/values", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "api/values" and http method "POST" to call the back-end.
    
        * @returns {void}
    ******************************************************************************************************/
    PostBinary: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/values", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
};
/*
$PrintDebugInfo
*/ 
//# sourceMappingURL=ValuesController.js.map